
/**
 * Agent is determined if the provided nick string starts with `agent:`.
 * 
 * This returns false if the nick string is falsey (undefined or "") or does not start with "agent:"
 * @param nick
 * @returns 
 */
export function isAgent(nick: string): boolean {
    if (!nick) {
        return false;
    }
    return nick.startsWith("agent:");
}

export function isBot(nick: string): boolean {
    if (!nick) {
        return false;
    }
    return nick.startsWith("bot:");
}